import styled, { css, keyframes } from "styled-components";
/* animation: ${(p) =>
    p.aboveAnim
      ? fadeInAnim
      : p.settingsA && !p.aboveAnim
      ? settingsOutAnim
      : fadeOutAnim};
  animation-fill-mode: forwards;
  animation-duration: 0.55s; */

const fadeInAnim = keyframes`
  0%{
     transform: translateY(75px);
     opacity:0
  }
  10%{
    transition-timing-function: cubic-bezier(0.42, 0, 0.07, 0.92);
    transform: translateY(75px);
    opacity:0
  }
  50%{
    transition-timing-function: cubic-bezier(0.29, 0.2, 0.62, 1);
    transform:translateY(-10px);
    opacity:0.5;
  }
  100%{
    transform:translateY(0px)
    opacity:1
   } 
`;

const fadeOutAnim = keyframes`
  0%{
    transition-timing-function: cubic-bezier(0.35, 0, 0.2, 1);
     transform: translateY(0);
     opacity:1;
    }
    100%{
      transform:translateY(123px);
      opacity:0;
   } 
`;

const fadeIn = css`
  ${fadeInAnim} 0.55s 1 forwards
`;
const fadeOut = css`
  ${fadeOutAnim} 0.55s 1 forwards
`;

export const TermsDiv = styled.div`
  animation: ${fadeIn};
  animation: ${(p) => (p.unBlur ? fadeOut : null)};

  overflow-y: scroll;
  -ms-overflow-style: none; // IE 10+
  scrollbar-width: none; // Firefox
  text-transform: none;
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  /* top: 0;
  right: 0;
  width: 100%;
  height: 100%; */
  /* top: -70px; */
  left: 0;
  width: 100%;
  min-height: 200%;
  /* max-height: 603px; */
  font-size: 12px;
  &&::-webkit-scrollbar {
    display: none;
  }
  background: #32075b;
  /* min-height: 100%; */
  color: #7f3da5;
  /* padding: 90px 8% 8%; */
`;

export const TermsBox = styled.div`
  /* padding: 30px; */
  scrollbar-width: none;

  max-width: 320px;
  overflow-y: scroll;
  margin: auto;
  position: relative;
  text-transform: none;
  p {
    text-transform: none;
  }
  height: 100%;
  &&::-webkit-scrollbar {
    display: none;
  }
`;
export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 0 30px;
  max-width: 320px;
  margin: auto;
  h1 {
    font-size: 26px;
  }
  div {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 36px;
    height: 36px;
    border-radius: 30px;
    background-color: #7f3da5;
    cursor: pointer;
  }

  @media only screen and (max-width: 374px) {
    h1 {
      font-size: 20px;
    }
  }
`;
export const Title = styled.div`
  text-transform: none;
  font-size: 20px;
  padding: 0 0 2.5%;
  max-width: 320px;
  margin: auto;
`;
export const Inner = styled.div`
  font-size: 12px;
  text-transform: none;
  padding: 0 0 2.67%;
  font-family: "GT America, regular";
  font-weight: 300;
  max-width: 320px;
  margin: auto;
  line-height: 1.44;
  li {
    text-transform: none;
    font-family: "GT America, regular";
    font-weight: 300;
  }
`;
